import { render, staticRenderFns } from "./TabStaffCommission.vue?vue&type=template&id=27bd6bde&"
import script from "./TabStaffCommission.vue?vue&type=script&lang=js&"
export * from "./TabStaffCommission.vue?vue&type=script&lang=js&"
import style0 from "./TabStaffCommission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports